<template>
  <q-page class="q-my-sm q-mx-lg">
    <div>
      <q-input
        v-model="supportSearch"
        dense
        label="Search support..."
        input-class="allow-global-search"
        autofocus
      />

      <div
        v-for="category in filteredCategories"
        :key="category.title"
        class="col q-col-gutter-lg"
      >
        <div
          class="text-h5"
          style="margin-top: 30px; margin-bottom: -30px;"
        >
          {{ category.title }}
        </div>
        <div class="row q-col-gutter-lg">
          <div
            v-for="video in category.videos"
            :key="video.slug"
            class="col-12 col-sm-6 col-md-4 col-lg-3"
          >
            <q-card
              class="cursor-pointer column"
              @click="playVideo(video)"
            >
              <q-img
                class="col"
                :ratio="16/9"
                :src="'https://img.youtube.com/vi/' + video.youtubeSlug + '/0.jpg'"
                @click="playVideo(video)"
              />

              <q-card-section class="col-auto">
                <div class="text-h6">
                  {{ video.title }}
                </div>
              </q-card-section>
            </q-card>
          </div>
        </div>
      </div>
    </div>
    <q-dialog
      v-model="showFullScreenVideo"
      full-width
    >
      <q-video
        style="width: 100%"
        :ratio="16/9"
        :src="'https://www.youtube.com/embed/' + youtubeSlug"
      />
    </q-dialog>
  </q-page>
</template>

<script>

export const categories = [
  {
    title: 'Overview',
    videos: [{
      title: 'Introduction to System',
      youtubeSlug: 'Z0RLboizEmU'
    }]
  },
  {
    title: 'Point of Sale',
    videos: [{
      title: 'Payments',
      youtubeSlug: 'PBv5eZsdNmA'
    },
    {
      title: 'Finding User',
      youtubeSlug: 'kOplYi3C4zE'
    },
    {
      title: 'Selling Tickets',
      youtubeSlug: 'SA6kCwy7KzQ'
    },
    {
      title: 'Concession Delivery',
      youtubeSlug: '6p2ock_rEcA'
    }]
  },
  {
    title: 'App and Website',
    videos: [{
      title: 'Overview of Website',
      youtubeSlug: 'n0-QPmFWBnI'
    },
    {
      title: 'Overview of App',
      youtubeSlug: 'qSntUmARYWg'
    }]
  },
  {
    title: 'Configuring Site',
    videos: [{
      title: 'Overview',
      youtubeSlug: 'pz-a9npIOxU'
    },
    {
      title: 'Building Seat Chart',
      youtubeSlug: 'WbZugw9RATY'
    },
    {
      title: 'Defining Concession Items',
      youtubeSlug: 'OmcNkIGLiNE'
    },
    {
      title: 'Configuring Register Stations',
      youtubeSlug: 'eh0IlURsykA'
    }]
  },
  {
    title: 'Configuring Promotions',
    videos: [{
      title: 'Overview',
      youtubeSlug: 'yhaqlYtomL0'
    },
    {
      title: 'Using Vouchers and Gift Cards',
      youtubeSlug: '9W-T8Jul5so'
    },
    {
      title: 'Using Points',
      youtubeSlug: 'YkKj5oCBoAk'
    },
    {
      title: 'Modify Membership',
      youtubeSlug: 'SQR0_64RxOQ'
    }]
  },
  {
    title: 'Programming',
    videos: [{
      title: 'Programming Concepts',
      youtubeSlug: 'VwWRpw3dJMc'
    },
    {
      title: 'Building Schedule Part 1: Booking Week Layout',
      youtubeSlug: '23zzzQ4MNFA'
    },
    {
      title: 'Building Schedule Part 2: Scheduling Times',
      youtubeSlug: 'CYVSG52kfJ4'
    },
    {
      title: 'Building Schedule Part 3: Copying and Customizing',
      youtubeSlug: '8lj_hrKsJvc'
    }]
  }
]

export default {
  name: 'Support',
  data: function () {
    return {
      supportSearch: '',
      showFullScreenVideo: false,
      youtubeSlug: null
    }
  },
  computed: {
    filteredCategories () {
      return this.buildList(categories)
    }
  },
  methods: {
    buildList (list, all = false) {
      const buildList = []

      _.each(list, listItem => {
        listItem = _.clone(listItem)
        if (all || _.includes(listItem.title.toLowerCase(), this.supportSearch.toLowerCase())) {
          buildList.push(listItem)
        } else {
          listItem.videos = this.buildList(listItem.videos)
          if (listItem.videos.length === 0) return

          buildList.push(listItem)
        }
      })

      return buildList
    },
    playVideo (video) {
      this.$trackEvent(this.$indyUserEvents.STARTED_SUPPORT_VIDEO, { video })
      this.showFullScreenVideo = true
      this.youtubeSlug = video.youtubeSlug
    }
  },
  trackPage: true
}
</script>

<style lang="scss" scoped>
</style>
